import PrimaryButton from './PrimaryButton'

class SidebarPrimaryButton extends PrimaryButton {}
export default SidebarPrimaryButton



// WEBPACK FOOTER //
// ./src/components/SidebarPrimaryButton.js